import React, { useEffect, useState } from 'react'
import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { Button, Form, Modal } from 'react-bootstrap';
import { MdAdd, MdDelete } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { addFutureSuggestion, addRemark, deleteFutureSuggestion, deleteRemark, getFutureSuggestion, getRemark, patientCallLog, updateFutureSuggestion, updateRemark } from '../../../redux/actions/Doctor.action';
import { FaEdit } from 'react-icons/fa';
import { PiWarningCircleBold } from 'react-icons/pi';
import { TiInputChecked } from 'react-icons/ti';
import userPhoto from '../../../assets/img/user.png'

const CallLogPatient = ({ patientIds }) => {

    const dispatch = useDispatch()
    const treatmentData = useSelector((state) => state.doctor)
    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(3);
    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    }

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        treatmentData?.patientCallLog?.data?.total / postPerPage,
    );

    useEffect(() => {
        if (patientIds) {
            dispatch(patientCallLog(patientIds, limits))
        }
    }, [mainPage, rowsPerPage, patientIds])


    return (
        <div className='col-lg-12'>

            <div className="!bg-[#fff] shadow p-4 rounded-4 mt-3">
                <div className="d-flex justify-between">
                    <div className="flex gap-3 items-center">
                        <TiInputChecked className="fs-5" />
                        <h6 className="mb-0">Call Log</h6>
                    </div>
                </div>
                <div className="mt-3">
                    <TableContainer>
                        <Table className="table-bordered">
                            <Thead className="!bg-theme-dark text-center">
                                <Tr>
                                    <Th className="!text-white">Date</Th>
                                    <Th className="!text-white">Branch</Th>
                                    <Th className="!text-white">Phone Number</Th>
                                    <Th className="!text-white">First Name</Th>
                                    <Th className="!text-white">Middle Name</Th>
                                    <Th className="!text-white">Last Name</Th>
                                    <Th className="!text-white">Gender</Th>
                                    <Th className="!text-white">Date of Birth</Th>
                                    <Th className="!text-white">Country</Th>
                                    <Th className="!text-white">State</Th>
                                    <Th className="!text-white">City</Th>
                                    <Th className="!text-white">Area</Th>
                                    <Th className="!text-white">Lead Received On</Th>
                                    <Th className="!text-white">Consult</Th>
                                    <Th className="!text-white">Lead Status</Th>
                                    <Th className="!text-white">Campaign</Th>
                                    <Th className="!text-white">Campaign Details</Th>
                                    <Th className="!text-white">Reference</Th>
                                    <Th className="!text-white">Remark</Th>
                                    <Th className="!text-white">Next Followup Date</Th>
                                    <Th className="!text-white">From</Th>
                                    <Th className="!text-white">To</Th>
                                    <Th className="!text-white">Nationality</Th>
                                    <Th className="!text-white">Doctor Name</Th>
                                    <Th className="!text-white">Counselor Assign</Th>
                                    <Th className="!text-white">Occupation</Th>
                                    <Th className="!text-white">Email</Th>
                                    <Th className="!text-white">Address</Th>
                                    <Th className="!text-white">Blood Group</Th>
                                    <Th className="!text-white">Pincode</Th>
                                    <Th className="!text-white">Lead FollowUp Remark</Th>
                                    <Th className="!text-white">Photo</Th>
                                    <Th className="!text-white">User</Th>
                                </Tr>
                            </Thead>
                            <Tbody className="">
                                {
                                    treatmentData?.patientCallLog?.data?.data?.length > 0 ? (
                                        treatmentData?.patientCallLog?.data?.data?.map((res) => {
                                            return (
                                                <Tr key={res._id}>
                                                    <Td>{new Date(res?.timestamp).toLocaleDateString('en-GB')}</Td>
                                                    <Td>{res?.updatedRecord?.branch}</Td>
                                                    <Td>{res?.updatedRecord?.phoneNumber}</Td>
                                                    <Td className='capitalize'>{res?.updatedRecord?.firstName}</Td>
                                                    <Td>{res?.updatedRecord?.middleName ? `${res?.updatedRecord?.middleName.charAt(0).toUpperCase()}.` : ''}</Td>
                                                    <Td className='capitalize'>{res?.updatedRecord?.lastName}</Td>
                                                    <Td>{res?.updatedRecord?.gender}</Td>
                                                    <Td>{new Date(res?.updatedRecord?.dateOfBirth).toLocaleDateString('en-GB')}</Td>
                                                    <Td>{res?.updatedRecord?.country}</Td>
                                                    <Td>{res?.updatedRecord?.state}</Td>
                                                    <Td>{res?.updatedRecord?.city}</Td>
                                                    <Td>{res?.updatedRecord?.area}</Td>
                                                    <Td>{res?.updatedRecord?.leadReceived}</Td>
                                                    <Td>{res?.updatedRecord?.problem}</Td>
                                                    <Td>{res?.updatedRecord?.leadStatus}</Td>
                                                    <Td>{res?.updatedRecord?.campaign?.length > 0 ? res.updatedRecord.campaign[0].cname : "N/A"}</Td>
                                                    <Td>{res?.updatedRecord?.campaign?.length > 0 ? res.updatedRecord.campaign[0].description : "N/A"}</Td>
                                                    <Td>
                                                        {res?.updatedRecord?.reference?.length > 0
                                                            ? res.updatedRecord.reference[0]?.doctorDetail || res.updatedRecord.reference[0]?.personDetail
                                                            : "N/A"}
                                                    </Td>
                                                    <Td>{res?.updatedRecord?.remark}</Td>
                                                    <Td>{new Date(res?.updatedRecord?.nextFollowUpDate).toLocaleDateString('en-GB')}</Td>
                                                    <Td>{res?.updatedRecord?.from ? new Date(res?.updatedRecord?.from).toLocaleTimeString() : ''}</Td>
                                                    <Td>{res?.updatedRecord?.to ? new Date(res?.updatedRecord?.to).toLocaleTimeString() : ''}</Td>
                                                    <Td>{res?.updatedRecord?.nationality}</Td>
                                                    <Td>{res?.updatedRecord?.doctorName}</Td>
                                                    <Td>{res?.updatedRecord?.counselorAssign}</Td>
                                                    <Td>{res?.updatedRecord?.occupation}</Td>
                                                    <Td>{res?.updatedRecord?.email}</Td>
                                                    <Td>{res?.updatedRecord?.addres}</Td>
                                                    <Td>{res?.updatedRecord?.bloodGroup}</Td>
                                                    <Td>{res?.updatedRecord?.pincode}</Td>
                                                    <Td>{res?.updatedRecord?.leadFollowUpRemark}</Td>
                                                    <Td><img src={res?.updatedRecord?.photo || userPhoto} alt='user photo' /></Td>
                                                    <Td>{res?.authName}</Td>
                                                </Tr>
                                            )
                                        })
                                    ) : (
                                        <Tr>
                                            <Td colSpan={31}> No any call log</Td>
                                        </Tr>
                                    )
                                }
                            </Tbody>
                        </Table>
                    </TableContainer>
                </div>
                <div className="flex justify-between items-center mt-2 text-sm">
                    <div>
                        Rows per page:
                        <select
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="ms-2 border rounded-md focus:outline-none"
                        >
                            <option value="" selected>Select</option>
                            <option value={3}>3</option>
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                        </select>
                    </div>
                    <ReactPaginate
                        breakLabel="..."
                        nextLabel=" >"
                        onPageChange={ChangeMainPage}
                        pageRangeDisplayed={5}
                        pageCount={PageCount}
                        previousLabel="< "
                        renderOnZeroPageCount={null}
                        className="pagination"
                    />
                </div>
            </div>
        </div>
    )
}

export default CallLogPatient
